(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breakpoint-indicator"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'bp-debug';

    function init() {
      var el = document.getElementById('breakpoint-indicator');
      if (!el) return;

      function apply() {
        el.style.display = localStorage.getItem(KEY) === '1' ? 'flex' : 'none';
      }

      function setWidth() {
        var w = el.querySelector('[data-bp-width]');
        if (w) w.textContent = window.innerWidth + 'px';
      }

      window.breakpointDebug = function (on) {
        var enabled = on !== false;
        localStorage.setItem(KEY, enabled ? '1' : '0');
        apply();
        return 'breakpoint indicator ' + (enabled ? 'on' : 'off');
      };

      window.addEventListener('resize', setWidth);
      setWidth();
      apply();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    // Fill delivery-estimate spans with a real date range (today + N working days,
  // weekends skipped). Done client-side so Shopify's page cache never serves a stale date.
  (function () {
    var locale = document.documentElement.lang || 'en';

    function addWorkingDays(days) {
      var d = new Date();
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    }

    document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      if (isNaN(min) || isNaN(max)) return;

      var earliest = addWorkingDays(min);
      var latest = addWorkingDays(max);
      // Both ends always get the full "Tue, Jul 14" format; the short same-month
      // variant renders day-first in en-US ("14 Tue") and reads as a bug.
      var format = new Intl.DateTimeFormat(locale, { weekday: 'short', month: 'short', day: 'numeric' });

      if (min === max) {
        el.textContent = format.format(latest);
      } else {
        el.textContent = format.format(earliest) + ' – ' + format.format(latest);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
